import { Box } from "@mui/material";
import React from "react";
import PDFViewer from "../components/Common/PDF/PDFViewer";
import StoryHeader from "../components/Story/StoryHeader";
import { ReactComponent as ResLove } from "../static/svg/reslove.svg";

const PolicyBrief = () => {
  return (
    <Box>
      <StoryHeader
        title2="Policy Brief"
        textColor="primary"
        icon={<ResLove />}
        imageSrc="https://res.cloudinary.com/mother-honestly/image/upload/v1675677394/Group_g4c5hj.png"
        imageMobSrc="https://res.cloudinary.com/mother-honestly/image/upload/v1675677394/Group_1_dyorkx.png"
        // Center Class attributes
        headerClassName="absolute items-center top-32 md:top-32 md:w-full w-[331px] text-center left-0 right-0 md:ml-auto md:mr-auto mx-auto"
        titleClassName="md:w-[688px] w-[331px] mx-auto"

        // Left Class attributes
        // headerClassName="absolute items-center top-32 md:top-40 lg:pl-10 lg:text-left text-center md:w-full w-[331px] text-center left-0 right-0 md:ml-auto md:mr-auto mx-auto"
      />
      <PDFViewer fileUrl="https://mh-resources-production.s3.us-west-1.amazonaws.com/Policy+Brief+Strengthening+Childcare+In+Nigeria.pdf" />
    </Box>
  );
};

export default PolicyBrief;
